import React from 'react';
import { Link } from 'react-router-dom';

// Adjust the following imports to match your file paths:
import LogoSVG from '../assets/BantrBoxLogo.svg';
import FeaturedImage from '../assets/blog-feature1.jpg';
import Footer from '../components/Footer';

const BlogPost1 = () => {
  return (
    <div className="bg-white text-gray-800 min-h-screen flex flex-col">
      {/* Header Bar */}
      <header className="bg-[#333333] shadow-sm text-white">
  <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between">
    <Link to="/" className="flex items-center">
      <img src={LogoSVG} alt="BantrBox Logo" className="h-12 w-auto" />
    </Link>
  </div>
</header>


      {/* Main Content */}
      <main className="flex-1 py-10 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Title & Date */}
          <h1 className="text-4xl font-bold mb-4 leading-tight">
            10 Creative Challenges to Spark Friendly Rivalry
          </h1>
          <p className="text-sm text-gray-500 mb-6">
            Published: September 25, 2024 • By BantrBox Team
          </p>

          {/* Featured Image */}
          <div className="w-full mb-8">
            <img
              src={FeaturedImage}
              alt="Creative Challenges"
              className="w-full h-auto rounded-lg shadow-lg object-cover"
            />
          </div>

          {/* Article Body */}
          <div className="space-y-6 leading-relaxed text-lg">
            <p>
              Friendly rivalries are the heartbeat of BantrBox — they bring people together, 
              fuel motivation, and create unforgettable stories to share. While typical bets 
              on sports or fitness can be fun, sometimes you want to go beyond the ordinary 
              and try something truly unique. Below are ten creative challenges guaranteed 
              to spice up your friendly competitions:
            </p>

            <ol className="list-decimal list-inside space-y-2">
              <li>
                <strong>Crazy Cuisine Cook-Off:</strong> Challenge a friend to recreate a dish 
                from a random country you both pick out of a hat. Taste-tests and hilarity 
                guaranteed.
              </li>
              <li>
                <strong>One Week, One Skill:</strong> Each person selects a skill (e.g., juggling, 
                speaking a new phrase in a foreign language) to master in a week. Post your 
                progress and let the community vote on who did best.
              </li>
              <li>
                <strong>Story Swap:</strong> Co-write a short story together, one paragraph at a 
                time, with a fun theme like “A day in outer space.” The funniest or most creative 
                storyline wins.
              </li>
              <li>
                <strong>Recycle Run:</strong> Set a timer for 15 minutes. The challenger who collects 
                the most recyclable items from their neighborhood gets bragging rights and helps 
                the planet, too.
              </li>
              <li>
                <strong>Playlist Face-Off:</strong> Create a themed music playlist (like “Party in 
                the 80s” or “Rainy Day Vibes”). Share with friends and see whose playlist gets the 
                most replays.
              </li>
              <li>
                <strong>2-Minute Talent Showcase:</strong> Dare each other to present a unique 
                talent in just 120 seconds. This could be anything from singing with a silly twist 
                to breakdancing attempts in your living room.
              </li>
              <li>
                <strong>Social Media Scavenger Hunt:</strong> Pick five obscure things to snap a 
                picture with (like a pink flamingo lawn ornament or a donut with sprinkles). 
                The first to post them all online wins.
              </li>
              <li>
                <strong>Handwritten Letter Race:</strong> Challenge a friend to write a heartfelt 
                note to a mutual buddy or family member. Whoever’s letter arrives first (snail 
                mail style) wins the bet.
              </li>
              <li>
                <strong>Art Attack:</strong> Choose a simple topic (like “cats in space”) and both 
                draw it in under five minutes. Post the results and let friends vote on the best 
                (or funniest) masterpiece.
              </li>
              <li>
                <strong>Book Swap Challenge:</strong> Each challenger recommends a favorite book 
                to the other. The first to finish reading and post a mini-review triumphs.
              </li>
            </ol>

            <p>
              Remember, creativity and fun are at the heart of these challenges. Keep it friendly, 
              encourage each other, and share your progress with the BantrBox community. You might 
              just discover a hidden talent or spark a new passion — all while scoring some epic 
              bragging rights!
            </p>

            <p className="italic">
              Ready to level up your friendly rivalries? Head back to BantrBox and create a 
              challenge your friends won’t be able to resist!
            </p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default BlogPost1;
